import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import QueryStringContext from '../../Contexts/QueryString';
import { getQueryString } from '../../Utility/QueryString';
import { getParameterByName } from '../../Utility/Helper';
import ReactPixel from 'react-facebook-pixel';
import VisitorParamsContext from '../../Contexts/VisitorParams';

// require("dotenv").config();
const FbPixel = () => {
  console.log('in fb ');
  const history = useHistory();
  const queryString = getQueryString();
  const field = 'pid';
  const { visitorParameters } = useContext(VisitorParamsContext);
  let current_domain = visitorParameters.data.existingdomain;
  const query = new URLSearchParams(window.location.search);
  const splitName = query.get('split_name');
  const nextPage = query.get('next_page');
  console.log('queryString outside', queryString);

  if (queryString != null) {
    console.log('queryString inside', queryString);
    if (queryString.indexOf('&' + field + '=') !== -1) {
      console.log('field found', field);
      const pid = getParameterByName(field, queryString);
      console.log('fb pixel iffff');
      console.log('vistors parameters');
      console.log(visitorParameters);
      // const advancedMatching = { em: 'some@email.com' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
      // const options = {
      //   autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
      //   debug: false, // enable logs
      // };
      // NOTE: Facebook Pixel functions are commented out per request from management/top level
      // ReactPixel.init(pid, advancedMatching, options);
      // ReactPixel.pageView();
      // ReactPixel.track('Lead');
      history.push(
        '/' +
          nextPage +
          '?uuid=' +
          visitorParameters.visitor_parameters.uuid +
          '&splitName=' +
          splitName +
          '&pid=' +
          pid
      );
    } else {
      console.log('else case');
    }
  }
  return <></>;
};

export default FbPixel;
